import { Group } from '@/components/_common';
import AccessDenied from '@/components/_common/AccessDenied';
import { useEmailReportLink } from '@/core/domain/questReport/EmailReportLink/EmailReportLink/EmailReportLink.hook';
import { useReportGenerate } from '@/hooks';
import LayoutPublicHeader from '@/layouts/PublicLayout/components/PublicHeader';
import { buildParamsStr, convertParams } from '@/utils/queryParams';
import { getUserFromLocalStorage } from '@/utils/user';
import { Button, Spin, Typography } from 'antd';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { AiOutlineFileDone } from 'react-icons/ai';
import { useHistory, useRouteMatch } from 'react-router-dom';
import './partsReport.less';
import moment from 'moment';

const { Text, Title } = Typography;

const PartsReport: React.FC = () => {
  const { params } = useRouteMatch<{ processId: string }>();
  const { type } = convertParams<{ type?: 'pdf' | 'csv' }>({ type: 'string' });
  const history = useHistory();
  const [accessDenied, setAccessDenied] = useState(false);

  const emailReport = useEmailReportLink();
  const reportGenerate = useReportGenerate();

  const userData = getUserFromLocalStorage();

  const handleDownload = async () => {
    if (params.processId) {
      try {
        const result = await emailReport.mutateAsync(params.processId);
        const isCSV = type?.includes('csv');

        reportGenerate.downloadFile({
          result,
          fileName: `peças-${moment().format('DDMMYYYYHHmmss')}.${
            isCSV ? 'csv' : 'pdf'
          }`,
        });
      } catch (error) {
        const err = error as AxiosError;

        if (err.response?.status === 401) return setAccessDenied(true);
      }
    }
  };

  useEffect(() => {
    if (userData.accessToken) {
      handleDownload();
    }
  }, [params.processId]);

  return (
    <div className="parts-report">
      <LayoutPublicHeader />

      <Group
        position="center"
        align="center"
        gap={16}
        style={{ width: '100%', height: '80vh', flexDirection: 'column' }}
      >
        {accessDenied && <AccessDenied />}

        {!userData.accessToken && (
          <>
            <Group style={{ textAlign: 'center', flexDirection: 'column' }}>
              <Title level={4} style={{ margin: 0, padding: 0 }}>
                Olá! Para baixar o relatório faça o login.
              </Title>

              <Text>
                Após o login bem-sucedido, você será redirecionado para tela do
                relatório.
              </Text>
            </Group>

            <Button
              type="primary"
              onClick={() =>
                history.push({
                  pathname: '/login',
                  search: buildParamsStr({
                    redirect: `/r/parts/${params.processId}?type=${type}`,
                  }),
                })
              }
            >
              Fazer o login
            </Button>
          </>
        )}

        {emailReport.isLoading && (
          <Group position="center" align="center" gap={16}>
            <Spin />
            <Title level={5}>Carregando...</Title>
          </Group>
        )}

        {!emailReport.isLoading && !!emailReport.data && (
          <>
            <Group gap={16} position="center">
              <AiOutlineFileDone size={24} />
              <Title level={3} style={{ margin: 0 }}>
                Concluído!
              </Title>
            </Group>

            <Group
              gap={16}
              style={{ textAlign: 'center', flexDirection: 'column' }}
            >
              <Text>
                Verifique a pasta de downloads para abrir o documento.
              </Text>

              <Text>
                Se o documento não foi baixado, tente novamente pelo link
                abaixo.
              </Text>

              <Button type="link" onClick={handleDownload}>
                Baixar documento
              </Button>
            </Group>
          </>
        )}
      </Group>
    </div>
  );
};

export default PartsReport;
